import {BaseFlexibleConfig} from '../base-flexible-config';
import { ModalityModel } from '../modality-model';
import { VisitType } from '../patient-model';

export interface GuerbetAdjConfigModel extends BaseFlexibleConfig {
    adjudicationBatchManagement: boolean;
    adjHideVisitChronology: string;
    visit?: any[];
    relatedConfigIds?: any[];
}

export class GUERBET_VisitModel{
    id?: number;
    created?: number;
    name: string;
    type?: VisitType;
    durationTimeUnit?: string;
    durationTimeValue?: number;
    baseline?: boolean;
    repeatAllowed?: boolean;
    modalities?: ModalityModel[];
    isAvailable = true;
  }
